module.exports = __webpack_public_path__ + "static/media/instagram.84541302.png";